module.exports = __webpack_public_path__ + "img/CTWP__Staff_05.550f40e3.png";